<script setup lang="ts">
import { onBeforeMount } from 'vue'

const props = defineProps<{
  tawkUrl: string
}>()

onBeforeMount(() => {
  const script = document.createElement('script')
  script.id = 'tawk-script'
  script.text = `var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
  (function() {
    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    s1.async=true;
    s1.src='${props.tawkUrl}';
    s1.charset='UTF-8';
    s1.setAttribute('crossorigin', '*');
    s1.id='tawk-script';
    s0.parentNode.insertBefore(s1,s0);
  })();`
  document.head.appendChild(script)
})
</script>

<template>
  <div w-full>
    <slot />
  </div>
</template>
